// Shared API base URL for Cloud Functions / local server.js

const isDevelopmentEnvironment = () => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  const port = window.location.port;
  const isLocalNetwork = /^(192\.168\.|10\.|172\.(1[6-9]|2[0-9]|3[0-1])\.)/.test(hostname);
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    isLocalNetwork ||
    port === '3000' ||
    process.env.NODE_ENV === 'development'
  );
};

/**
 * Base URL for the local Express API (server.js). Uses the current page hostname so
 * opening the app as http://192.168.x.x:3001 still calls http://192.168.x.x:4000.
 */
function getDevelopmentApiOrigin() {
  if (typeof window === 'undefined') return 'http://localhost:4000';
  return `http://${window.location.hostname}:4000`;
}

export const getApiBaseUrl = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL || '';
  const isDevelopment = isDevelopmentEnvironment();

  if (API_BASE_URL) {
    return API_BASE_URL;
  }

  if (isDevelopment) {
    return getDevelopmentApiOrigin();
  }

  return 'https://us-central1-epiphoric-prod.cloudfunctions.net/api';
};

/**
 * Build full HTTPS URL for an API route (handles dev vs prod /api prefix).
 * Express routes use /api/...; Cloud Function export name is `api` → prod uses /api/api/...
 * @param {string} endpoint e.g. /enhance-idea or /api/admin/entitlement-list
 */
export const getApiEndpoint = (endpoint) => {
  const baseUrl = getApiBaseUrl();
  let normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

  if (!normalizedEndpoint.startsWith('/api/')) {
    normalizedEndpoint = `/api${normalizedEndpoint}`;
  }

  return `${baseUrl}${normalizedEndpoint}`;
};
